import _regeneratorRuntime from '/var/www/html/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/var/www/html/node_modules/babel-runtime/helpers/asyncToGenerator';
import cookie from 'cookie';
import axios from 'axios';
import $ from 'jquery';

export default (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
    var requestLang, routeName, parsedCookies, cookieOptions, expDate;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            requestLang = context.route.params.lang;
            routeName = context.route.name;
            parsedCookies = {};

            //
            // cookie options
            //

            cookieOptions = { path: '/' };


            if (global.websiteSettings.extra_info.cookie_domain) {
              cookieOptions.domain = global.websiteSettings.extra_info.cookie_domain;
            }

            expDate = new Date();

            expDate.setFullYear(expDate.getFullYear() + 10);
            cookieOptions.expires = expDate;

            if (process.server) {

              parsedCookies = context.req.headers.cookie ? cookie.parse(context.req.headers.cookie) : {};
            } else {
              parsedCookies = cookie.parse(document.cookie);
              axios.get(global.getEndPoint() + 'api/common/geo-country').then(function (res) {
                var geoCountryCode = res.data.country;

                //
                // signup email exp
                //
                if (typeof parsedCookies.utm_signup_email_exp == 'undefined') {
                  var signupEmailExp = 'signup_mandatory_email';

                  global.signupEmailExp = signupEmailExp;
                  document.cookie = cookie.serialize('utm_signup_email_exp', signupEmailExp, cookieOptions) + '; ' + document.cookie;
                  parsedCookies = cookie.parse(document.cookie);
                }

                //
                // signup email exp
                //
                if (typeof parsedCookies.utm_signup_new_design_exp == 'undefined') {
                  var signupNewDesignExp = 'signup_old_design';

                  global.signupNewDesignExp = signupNewDesignExp;
                  document.cookie = cookie.serialize('utm_signup_new_design_exp', signupNewDesignExp, cookieOptions) + '; ' + document.cookie;
                  parsedCookies = cookie.parse(document.cookie);
                }

                //
                // price new design exp
                //
                if (typeof parsedCookies.utm_price_new_design_exp == 'undefined') {
                  var priceNewDesignExp = 'price_old_design';

                  switch (geoCountryCode) {
                    case 'SA':
                      if (Math.random() * 100 < 50) {
                        priceNewDesignExp = 'price_new_design';
                      }
                      break;
                  }

                  global.priceNewDesignExp = priceNewDesignExp;
                  document.cookie = cookie.serialize('utm_price_new_design_exp', priceNewDesignExp, cookieOptions) + '; ' + document.cookie;
                  parsedCookies = cookie.parse(document.cookie);
                }

                if (typeof parsedCookies.utm_abexperement == 'undefined') {
                  global.getPaymentMethodId().then(function (pres) {
                    if (pres == 'tpay' || pres == 'stripe' || pres === 'paymentwall') {
                      var doExp = 2;

                      //
                      // main exp
                      //
                      switch (geoCountryCode) {
                        case 'AE':
                        case 'SA':
                          if (pres == 'stripe') {
                            doExp = 2;
                            break;
                          }

                        case 'EG':
                          if (pres == 'tpay') {
                            doExp = 2;
                            break;
                          }

                        case 'KW':
                        case 'BH':
                        case 'US':
                        case 'JO':
                          doExp = 2;
                          break;
                        case 'OM':
                          if (pres == 'stripe') {
                            doExp = 2; //Math.floor(Math.random() * 2);
                          } else if (global.utmPayment == 'dcb2') {
                            doExp = 2;
                          }
                          break;

                        case 'QA':
                        case 'PS':
                        case 'TN':
                        case 'LY':
                          doExp = 2;
                          break;
                        case 'GB':
                        case 'AU':
                          doExp = 2;
                          break;
                      }
                      var newExpPriceForOverSea = [];
                      if (doExp == 2 && pres == 'stripe') {
                        if (geoCountryCode == 'AE' || geoCountryCode == 'QA') {
                          doExp = 4;
                        } else if (geoCountryCode == 'PS' || geoCountryCode == 'TN' || geoCountryCode == 'OM' || geoCountryCode == 'KW' || geoCountryCode == 'BH' || geoCountryCode == 'LY') {
                          doExp = 2;
                        } else if (geoCountryCode == 'SA' && requestLang == 'ar') {
                          doExp = 2;
                        } else if (geoCountryCode == 'SA' && requestLang == 'en') {
                          doExp = 4;
                        } else if (Math.random() * 100 < 50) {
                          doExp = 2;
                        } else {
                          doExp = 4;
                        }
                      }
                      if (pres === 'stripe') {
                        if (newExpPriceForOverSea.includes(geoCountryCode)) {
                          if (Math.random() * 100 < 50) {
                            doExp = 5;
                          } else {
                            doExp = 6;
                          }
                        }

                        if (geoCountryCode == 'US' || geoCountryCode == 'GB' || geoCountryCode == 'AU' || geoCountryCode == 'CA') {
                          doExp = 6;
                        }
                      }

                      /**
                       * geoCountryCode == 'ZA' || geoCountryCode == 'CA' || geoCountryCode == 'US' || geoCountryCode == 'AU' || geoCountryCode == 'NZ'
                       */
                      // Google A/B Test | Google Splitting
                      if (geoCountryCode == 'GB' || geoCountryCode == 'US' || geoCountryCode == 'CA' || geoCountryCode == 'ZA' || geoCountryCode == 'AU') {

                        // v1
                        if (routeName === 'lang-flow---MQ==') {
                          doExp = 10;
                        }

                        // v2
                        if (routeName === 'lang-flow---Mg==') {
                          doExp = 11;
                        }
                      }

                      document.cookie = cookie.serialize('utm_abexperement', doExp, cookieOptions) + '; ' + document.cookie;
                      parsedCookies = cookie.parse(document.cookie);

                      global.expPlace = doExp === 1 ? 'after_search' : 'after_loading';
                      global.agreementBelowButton = doExp === 4 ? true : false;

                      global.resetAxiosHeaders();
                    }
                  });
                }
              });
            }

            global.expPlace = parseInt(parsedCookies.utm_abexperement) === 1 ? 'after_search' : 'after_loading';
            global.agreementBelowButton = parseInt(parsedCookies.utm_abexperement) === 4 ? true : false;
            global.signupEmailExp = parsedCookies.utm_signup_email_exp;
            global.signupNewDesignExp = parsedCookies.utm_signup_new_design_exp;
            global.priceNewDesignExp = parsedCookies.utm_price_new_design_exp;

            global.dcbAbTestSearchButtonClick = function (isAuth) {

              $('.loading-page').show();

              try {
                global.dcbCreateFakeQuestion();

                if (!isAuth) {
                  global.getPaymentMethodId().then(function (pres) {
                    if (pres === 'stripe' || pres === 'paymentwall') {
                      context.redirect('/' + context.route.params.lang + '/signup');
                      $('.loading-page').hide();
                    }
                  });
                } else {
                  $('.loading-page').hide();
                  context.redirect('/' + context.route.params.lang + '/search-results/' + customSessionStorage.getItem('lastSearchType') + '/' + customSessionStorage.getItem('lastSearchText') + '/loading');
                }
              } catch (e) {
                $('.loading-page').hide();
                throw e;
              }
            };

            global.dcbCreateFakeQuestion = function (callback) {
              var searchType = customSessionStorage.getItem('lastSearchType');
              if (searchType == 'name') {
                searchType = 'raw_name';
              }
              axios.get(global.getEndPoint() + 'api/create-fake-query?search_keyword=' + customSessionStorage.getItem('lastSearchText') + '&search_type=' + searchType).then(function (res1) {
                axios.get(global.getEndPoint() + 'api/payment/package/tpay');
              });
            };

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();


//////////////////
// WEBPACK FOOTER
// ./plugins/dcb-ab-test.js
// module id = ./plugins/dcb-ab-test.js
// module chunks = 54